<template>
  <div class="quote-request-page">
    <header class="page-header">
      <div class="header-content">
        <div class="header-title">
          <h1>Solicitar Cotação Seguro</h1>
          <p class="subtitle">Preencha os dados abaixo para solicitar sua cotação de seguro</p>
        </div>
        <div class="header-badge">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 12l2 2 4-4"></path>
            <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"></path>
            <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"></path>
            <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"></path>
            <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"></path>
          </svg>
          <span>Processo Seguro</span>
        </div>
      </div>
    </header>

    <main class="page-main">
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>Carregando formulário...</p>
      </div>

      <div v-else-if="error" class="error-container">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
        <h3>Erro ao carregar</h3>
        <p>{{ error }}</p>
        <button @click="retry" class="btn-retry">Tentar Novamente</button>
      </div>

      <div v-else class="form-container">
        <QuoteForm :serial="serial" :site-key="cloudflareSiteKey" @success="handleSuccess" @error="handleError" />
      </div>
    </main>

    <footer class="page-footer">
      <p>VR Tech</p>
    </footer>
  </div>
</template>

<script>
import QuoteForm from '../components/QuoteForm.vue'
import api from '../services/api'

export default {
  name: 'QuoteRequestPage',
  components: {
    QuoteForm
  },
  data() {
    return {
      serial: '',
      cloudflareSiteKey: '',
      loading: true,
      error: null
    }
  },
  async mounted() {
    await this.initializePage()
  },
  methods: {
    async initializePage() {
      try {
        // Extrair serial da URL
        this.serial = this.$route.query.serial || ''

        if (!this.serial) {
          this.error = 'Parâmetro serial é obrigatório na URL'
          this.loading = false
          return
        }

        // Buscar configurações do Cloudflare
        await this.loadCloudflareConfig()

        this.loading = false
      } catch (err) {
        console.error('Erro ao inicializar página:', err)
        this.error = 'Erro ao carregar a página. Tente novamente.'
        this.loading = false
      }
    },

    async loadCloudflareConfig() {
      try {
        // Buscar configuração do Cloudflare do backend
        const response = await api.get('/auth/config')
        this.cloudflareSiteKey = response.data.siteKey
        
        console.log('Cloudflare Site Key carregada:', this.cloudflareSiteKey)
      } catch (err) {
        console.error('Erro ao carregar configuração do Cloudflare:', err)
        // Fallback para chave de teste em caso de erro
        this.cloudflareSiteKey = '1x00000000000000000000AA'
        console.warn('Usando chave de teste do Cloudflare como fallback')
      }
    },

    handleSuccess(response) {
      console.log('Cotação enviada com sucesso:', response)

      // Extrair o ID da cotação da resposta
      const quoteId = response.QuoteIde || response.quoteIde || response.id

      // Redirecionar para página de confirmação
      this.$router.push({
        name: 'Confirmation',
        query: {
          quoteId: quoteId,
          serial: this.serial
        }
      })
    },

    handleError(error) {
      console.error('Erro ao enviar cotação:', error)

      // Mostrar mensagem de erro amigável
      let errorMessage = 'Erro ao enviar cotação. Tente novamente.'

      if (error.response?.data?.message) {
        errorMessage = error.response.data.message
      } else if (error.message) {
        errorMessage = error.message
      }

      // Aqui você pode implementar um sistema de notificações
      alert(errorMessage)
    },

    retry() {
      this.loading = true
      this.error = null
      this.initializePage()
    }
  }
}
</script>

<style scoped>
.quote-request-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  display: flex;
  flex-direction: column;
}

.page-header {
  background: linear-gradient(135deg, #244179 0%, #365494 100%);
  color: white;
  padding: 2rem 0;
  box-shadow: 0 4px 20px rgba(36, 65, 121, 0.3);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.header-title h1 {
  margin: 0;
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.subtitle {
  margin: 0.5rem 0 0 0;
  font-size: 1.125rem;
  opacity: 0.9;
  font-weight: 400;
}

.header-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-badge span {
  font-weight: 600;
  font-size: 0.875rem;
}

.page-main {
  flex: 1;
  padding: 2rem 0;
}

.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  padding: 2rem;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e9ecef;
  border-top: 4px solid #244179;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

.error-container svg {
  color: #dc3545;
  margin-bottom: 1rem;
}

.error-container h3 {
  margin: 0 0 0.5rem 0;
  color: #dc3545;
  font-size: 1.25rem;
}

.error-container p {
  margin: 0 0 1.5rem 0;
  color: #6c757d;
}

.btn-retry {
  background: #244179;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-retry:hover {
  background: #365494;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(36, 65, 121, 0.3);
}

.form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.page-footer {
  background: #244179;
  color: white;
  text-align: center;
  padding: 1.5rem 0;
  margin-top: auto;
}

.page-footer p {
  margin: 0;
  font-weight: 600;
  font-size: 1rem;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    text-align: center;
    padding: 0 1rem;
  }

  .header-title h1 {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .header-badge {
    padding: 0.5rem 1rem;
  }

  .page-main {
    padding: 1rem 0;
  }

  .form-container {
    padding: 0 0.5rem;
  }
}

@media (max-width: 480px) {
  .header-title h1 {
    font-size: 1.75rem;
  }

  .subtitle {
    font-size: 0.875rem;
  }

  .header-badge {
    font-size: 0.8rem;
    padding: 0.5rem 0.75rem;
  }
}
</style>
